import { render } from "./SolucoesEscolares.vue?vue&type=template&id=cd476492"
import script from "./SolucoesEscolares.vue?vue&type=script&lang=js"
export * from "./SolucoesEscolares.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__